import { haveDisjointRegistrableDomains } from "../../shared/registrableDomains";

export function pdfPreviewOrigin(edgeOrigin: string): string | null {
  const edge = new URL(edgeOrigin);
  const app = new URL(location.href);
  if (!edge.hostname.includes(".") || !app.hostname.includes(".")) return null;
  return haveDisjointRegistrableDomains(edge.hostname, app.hostname)
    ? edge.origin
    : null;
}
